export enum PillarTwo {
    CMT_CLICK = 'pillarTwo.cmtClick',
    EDIT_CMT_CLICK = 'pillarTwo.editCmtClick',
    EDIT_CMT_YES_CLICK = 'pillarTwo.editCmtYesClick',
    EDIT_CMT_NO_CLICK = 'pillarTwo.editCmtNoClick',
    EDIT_CMT_DISMISS = 'pillarTwo.editCmtDismiss',
}
